import R from 'app/assets/R'
import {
  FunctionPermissionEnum,
  ModulePermissionEnum,
} from 'app/common/permission-module'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import { FilterLayout } from 'app/components/tables/BaseTableManagement/FilterManagementTableV2'
import * as S from 'app/components/tables/BaseTableManagement/styles'
import { useGetHeightTable } from 'app/hook'
import { useTranslation } from 'react-i18next'
import { CreateRole } from './components/CreateRole'
import { useHookTable } from './hook'
const RoleManagementContainer = () => {
  const { t } = useTranslation()
  const {
    tableData,
    columns,
    handleTableChange,
    handleChangeFilter,
    fetchNewData,
    filter,
    isHavePermissionFunction,
  } = useHookTable()

  return (
    <S.BaseManagementWrapper>
      <S.RootWrapper size={8}>
        <BaseRow justify={'space-between'} align={'middle'} gutter={8}>
          <BaseCol>
            <FilterLayout
              handleChangeFilter={handleChangeFilter}
              filterData={filter}
              placeholderSearch={t(R.strings.role_content_enter_role)}
            />
          </BaseCol>

          {isHavePermissionFunction(
            ModulePermissionEnum.HR,
            FunctionPermissionEnum.ROLES_CREATE,
          ) ? (
            <BaseCol>
              <CreateRole fetchTable={fetchNewData} />
            </BaseCol>
          ) : null}
        </BaseRow>
        <BaseTableManagement
          columns={columns}
          dataSource={tableData.data}
          pagination={tableData.pagination}
          loading={tableData.loading}
          onChange={handleTableChange}
          scroll={{
            x: true,
            y: tableData?.data?.length ? useGetHeightTable(195, 30) : undefined,
          }}
        />
      </S.RootWrapper>
    </S.BaseManagementWrapper>
  )
}
export default RoleManagementContainer
